import { useState } from 'react';
import backgroundImage from "../../assets/images/REIBanner-2.webp";
import axios from 'axios';
import Captcha from '../../component/Captcha';

export default function REIExpoForm() {
    // State updated: Added 'remark', removed 'requirementOther' and 'capacityOther'
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        city: '',
        requirement: 'Solar Modules',
        capacity: 'Other',
        remark: ''
    });

    const [captchaValue, setCaptchaValue] = useState('');
    const [resetCaptcha, setResetCaptcha] = useState(false);
    const [captchaInput, setCaptchaInput] = useState('');
    const [loading, setLoading] = useState(false);

    const handleCaptchaChange = (value) => {
        setCaptchaInput(value);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (captchaInput === captchaValue) {
            setLoading(true);
            alert('CAPTCHA Verified!');
            let utm = localStorage.getItem('utm_data') || {};

          

            let Formdata = {};
            // Appending fields to FormData
            Formdata.name= formData.name
            Formdata.mobile=formData.mobile;
            Formdata.city= formData.city;
            Formdata.requirement= formData.requirement;
            Formdata.capacity=formData.capacity;
            Formdata.remark= formData.remark;
            Formdata.utm=utm

            try {
                let res = await axios.post('https://gautamsolar.us/submit-rei-form', Formdata);
                // let res = await axios.post('http://localhost:1008/submit-rei-form', Formdata);
                if (res?.data?.success) {
                    alert(res?.data?.message);
                    setLoading(false);
                    // window.location.reload();
                }
            } catch (er) {
                console.log(er);
                // window.location.reload();
            }
            finally{
                 window.location.reload();
            }
        } else {
            alert('CAPTCHA Verification Failed! Please try again.');
        }
    };

    const styles = {
        container: {
            minHeight: '100vh',
            background: '#f5f5f5',
            padding: '20px',
            boxSizing: 'border-box'
        },
        card: {
            maxWidth: '1200px',
            margin: '0 auto',
            background: 'white',
            borderRadius: '20px',
            overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
        },
        imageSection: {
            padding: '10px',
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '300px',
            className: 'image-section'
        },
        imageContent: {
            width: '100%',
            position: 'relative',
            zIndex: 2
        },
        expoImage: {
            width: '100%',
            height: 'auto',
            borderRadius: '10px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
            display: 'block'
        },
        formSection: {
            padding: '40px 30px',
            background: 'white',
            className: 'form-section'
        },
        formTitle: {
            fontSize: '2em',
            fontWeight: '600',
            marginBottom: '30px',
            color: '#333',
            textAlign: 'center',
            lineHeight: '1.2'
        },
        fieldGroup: {
            marginBottom: '20px'
        },
        fieldRow: {
            lineHeight: '1.5'
        },
        label: {
            fontWeight: '600',
            color: '#555',
            marginBottom: '8px',
            display: 'block',
            fontSize: '0.95em'
        },
        input: {
            width: '100%',
            borderRadius: '10px',
            border: '2px solid #e0e0e0',
            padding: '12px 16px',
            fontSize: '1em',
            transition: 'all 0.3s',
            boxSizing: 'border-box',
            fontFamily: 'inherit'
        },
        radioGroup: {
            display: 'flex',
            flexDirection: 'column',
            gap: '10px'
        },
        radioLabel: (isSelected) => ({
            display: 'flex',
            alignItems: 'center',
            padding: '12px 20px',
            border: '2px solid',
            borderColor: isSelected ? '#a20000' : '#e0e0e0',
            background: isSelected ? '#ffe5e5' : 'white',
            borderRadius: '10px',
            cursor: 'pointer',
            transition: 'all 0.3s',
            fontSize: '0.95em',
            className: 'radio-label'
        }),
        submitBtn: {
            background: '#a20000',
            border: 'none',
            borderRadius: '10px',
            padding: '15px 40px',
            fontSize: '1.1em',
            fontWeight: '600',
            color: 'white',
            transition: 'all 0.3s',
            boxShadow: '0 4px 15px rgba(162, 0, 0, 0.4)',
            cursor: 'pointer'
        },
        circle1: {
            position: 'absolute',
            width: '300px',
            height: '300px',
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '50%',
            top: '-100px',
            right: '-100px',
            zIndex: 1
        },
        circle2: {
            position: 'absolute',
            width: '200px',
            height: '200px',
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '50%',
            bottom: '-50px',
            left: '-50px',
            zIndex: 1
        },
        heading: {
            textAlign: 'center',
            marginBottom: '30px',
            padding: '0 20px'
        },
        mainHeading: {
            fontSize: '2.5em',
            fontWeight: '700',
            color: '#a20000',
            marginBottom: '10px',
            textTransform: 'uppercase',
            letterSpacing: '1px'
        },
        boothInfo: {
            fontSize: '1.3em',
            fontWeight: '600',
            color: '#333',
            margin: '0'
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.heading}>
                <h1 style={styles.mainHeading}>Visit Gautam Solar</h1>
                <p style={styles.boothInfo} className="booth-info">Booth No. B-85, Hall No. 9</p>
            </div>

            <div style={styles.card}>
                {/* Image Section */}
                <div style={styles.imageSection} className="image-section">
                    <div style={styles.circle1}></div>
                    <div style={styles.circle2}></div>
                    <div style={styles.imageContent}>
                        <img
                            src={backgroundImage}
                            alt="Gautam Solar REI Expo 2025"
                            style={styles.expoImage}
                        />
                    </div>
                </div>

                {/* Form Section */}
                <div style={styles.formSection} className="form-section">
                    <h2 style={styles.formTitle}>Registration Form</h2>

                    <form onSubmit={handleSubmit}>
                        {/* Name */}
                        <div style={styles.fieldGroup}>
                            <label style={styles.label}>Name *</label>
                            <input
                                type="text"
                                style={styles.input}
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                placeholder="Your answer"
                            />
                        </div>

                        {/* Mobile Number */}
                        <div style={styles.fieldGroup}>
                            <label style={styles.label}>Mobile Number *</label>
                            <input
                                type="tel"
                                style={styles.input}
                                name="mobile"
                                value={formData.mobile}
                                onChange={handleChange}
                                required
                                placeholder="Your answer"
                            />
                        </div>

                        {/* City */}
                        <div style={styles.fieldGroup}>
                            <label style={styles.label}>City *</label>
                            <input
                                type="text"
                                style={styles.input}
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                                required
                                placeholder="Your answer"
                            />
                        </div>

                        {/* Requirement */}
                        <div style={styles.fieldGroup}>
                            <label style={styles.label}>What is your requirement? *</label>
                            <div style={styles.radioGroup}>
                                {['Solar Modules', 'Solar Inverters', 'Solar Power Plant ', 'Battery ESS (BESS)', 'Other'].map((option) => (
                                    <label key={option} style={styles.radioLabel(formData.requirement === option)}>
                                        <input
                                            type="radio"
                                            name="requirement"
                                            value={option}
                                            checked={formData.requirement === option}
                                            onChange={handleChange}
                                            style={{ marginRight: '8px', accentColor: '#a20000' }}
                                        />
                                        {option}
                                    </label>
                                ))}
                            </div>
                        </div>

                        {/* Required Solar Capacity */}
                        <div style={styles.fieldGroup}>
                            <label style={styles.label}>What is your required solar capacity? </label>
                            <div style={styles.radioGroup}>
                                {['Above 10 MW', '1 MW - 10 MW', '500 kW - 1 MW', '100 kW - 500 kW', 'Other'].map((option) => (
                                    <label key={option} style={styles.radioLabel(formData.capacity === option)}>
                                        <input
                                            type="radio"
                                            name="capacity"
                                            value={option}
                                            checked={formData.capacity === option}
                                            onChange={handleChange}
                                            style={{ marginRight: '8px', accentColor: '#a20000' }}
                                        />
                                        {option}
                                    </label>
                                ))}
                            </div>
                        </div>

                        {/* Remark Field (Added back) */}
                        <div style={styles.fieldGroup}>
                            <label style={styles.label}>Remark</label>
                            <textarea
                                style={{ ...styles.input, minHeight: '100px', resize: 'vertical' }}
                                name="remark"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter your remarks or additional information"
                            />
                        </div>

                        <div className="text-center mt-4 p-1 border-top">
                            <Captcha
                                captchaValue={captchaValue}
                                setCaptchaValue={setCaptchaValue}
                                handleCaptchaChange={handleCaptchaChange}
                                resetCaptcha={resetCaptcha}
                                setResetCaptcha={setResetCaptcha}
                            />

                            <button
                                disabled={loading === true}
                                type="submit"
                                style={styles.submitBtn}
                                onMouseOver={(e) => {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.background = '#8a0000';
                                }}
                                onMouseOut={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.background = '#a20000';
                                }}
                            >
                                {loading ?
                                    <div className="spinner-border text-white" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                    :
                                    'Submit Registration'
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <style>{`
                @media (max-width: 768px) {
                    h2 { font-size: 1.5em !important; }
                }
                @media (max-width: 600px) {
                    h1 { font-size: 1.8em !important; }
                }
                @media (max-width: 480px) {
                    h1 { font-size: 1.5em !important; }
                    h2 { font-size: 1.3em !important; margin-bottom: 20px !important; }
                    label { font-size: 0.85em !important; }
                    input, select, textarea { font-size: 0.9em !important; padding: 10px 12px !important; }
                    .radio-label { font-size: 0.85em !important; padding: 10px 15px !important; }
                    button { font-size: 1em !important; padding: 12px 30px !important; }
                    .form-section { padding: 30px 20px !important; }
                    .image-section { padding: 30px 20px !important; }
                    .booth-info { font-size: 1.1em !important; }
                }
            `}</style>
        </div>
    );
}